import { saveAs } from 'file-saver';
import {
  downloadCandidatesData,
  downloadJobsData,
  getDataDownloadSettings,
  IDataDownloadSettingsDTO,
  IJobCandidateInteraction,
  IJobSearchFilterDTO,
  downloadWorkspaceUsersData,
  NewSubmissionDownloadPayLoad,
  downloadSubmissionsNew,
  downloadSubmissionCandidatesData,
} from 'wisestep-api';
import { formattedDateISO } from 'wisestep-base';

import { getWorkspaceToken, getAuthToken, getCookieByName } from '../../../utils/token';
export const jobsDownloadPayload = (
  postedFromDate,
  postedToDate,
  updatedFromDate,
  updatedToDate
) => {
  return {
    jobAssignmentStatusFilter: 'All',
    postedFromDate: postedFromDate,
    postedToDate: postedToDate,
    page: 0,
    size: 50,
    sort: ['postedDate,desc'],
    jobAssignmentStatus: 'All',
    updatedFromDate: updatedFromDate,
    updatedToDate: updatedToDate,
    searchAcross: ['MY_TEAMS', 'MY_PERSONAL_DATA'],
  };
};
export const candidatesDownloadPayload = (
  postedFromDate,
  postedToDate,
  updatedFromDate,
  updatedToDate
) => {
  return {
    fromDate: postedFromDate,
    toDate: postedToDate,
    page: 0,
    size: 50,
    sort: ['createdOn,desc'],
    datesUnionBy: 'CREATED_OR_UPDATED_BETWEEN',
    updatedFromDate: updatedFromDate,
    updatedToDate: updatedToDate,
    searchAcross: ['BELONG_TO_TEAMS', 'OWN_TEAMS'],
  };
};
export const cvDownloadPayload = (postedFromDate, postedToDate, updatedFromDate, updatedToDate) => {
  return {
    datesUnionBy: 'CREATED_OR_UPDATED_BETWEEN',
    fromDateTime: postedFromDate,
    toDateTime: postedToDate,
    updatedFromDate: updatedFromDate,
    updatedToDate: updatedToDate,
  };
};
export const jsonToFormData = (data) => {
  const searchParams = formatter(data);
  return searchParams;
};
export const urlAndQueryBuilderCandidates = (
  allowedColumns: string[],
  postedFromDate,
  postedToDate,
  updatedFromDate,
  updatedToDate,
  locations?
) => {
  const payload = candidatesDownloadPayload(
    postedFromDate,
    postedToDate,
    updatedFromDate,
    updatedToDate
  );
  const url = `candidatesearch/api/mapping/_search/advanced.xls?filter=${JSON.stringify(
    allowedColumns
  )}&jobLocationsData=${encodeURIComponent(
    JSON.stringify({ jobLocations: locations })
  )}&candidateLocationsData=${encodeURIComponent(
    JSON.stringify({ candidateLocations: [] })
  )}&currentStageCurrentStatusData=${encodeURIComponent(
    JSON.stringify({ currentStageCurrentStatusPairs: {} })
  )}&_csrf=${getCookieByName(
    'XSRF-TOKEN'
  )}&Authorization=Bearer ${getAuthToken()}&X-Workspace-Token=${getWorkspaceToken()}`;
  return { payload, url };
};
export const urlAndQueryBuilderJobs = (
  allowedColumns: string[],
  postedFromDate,
  postedToDate,
  updatedFromDate,
  updatedToDate
) => {
  const payload = jobsDownloadPayload(postedFromDate, postedToDate, updatedFromDate, updatedToDate);
  const url = `jobsearch/api/_search/jobs/advanced.xls?filter=${JSON.stringify(
    allowedColumns
  )}&jobLocationsData=${encodeURIComponent(
    JSON.stringify({})
  )}&candidateLocationsData=${encodeURIComponent(
    JSON.stringify({ candidateLocations: [] })
  )}&currentStageCurrentStatusData=${encodeURIComponent(
    JSON.stringify({})
  )}&_csrf=${getCookieByName(
    'XSRF-TOKEN'
  )}&Authorization=Bearer ${getAuthToken()}&X-Workspace-Token=${getWorkspaceToken()}`;
  return { payload, url };
};
export const downloadHelper = (response) => {
  const downloadDetails = response;
  const headers = downloadDetails.headers;
  const file = new Blob([downloadDetails.data], {
    type: headers['content-type'],
  });
  saveAs(file, headers['content-disposition'].replace('attachment; filename=', ''));
};

export const CandidatesDownloadPayload = (
  query: IJobCandidateInteraction,
  downloadSettings: IDataDownloadSettingsDTO
) => {
  return {
    ...query,
    ...(query.fromDateTime && { fromDateTime: formattedDateISO(query.fromDateTime ?? '') }),
    ...(query.toDateTime && { toDateTime: formattedDateISO(query.toDateTime ?? '') }),
    ...(query.toDate && { toDate: formattedDateISO(query.toDate ?? '') }),
    ...(query.fromDate && { fromDate: formattedDateISO(query.fromDate ?? '') }),
    ...(query.updatedFromDate && {
      updatedFromDate: formattedDateISO(query.updatedFromDate ?? ''),
    }),
    ...(query.updatedToDate && { updatedToDate: formattedDateISO(query.updatedToDate ?? '') }),
    searchScope: query.searchScope,
    minSalary: query.minSalary,
    maxSalary: query.maxSalary,
    searchAcross: query.searchAcross ?? 'CRM_TEAM_SHARING',
    aggregationFields: query.aggregationFields ?? 'ApplicationStageStatus',
    noticePeriodMinDays: query.noticePeriodMinDays,
    noticePeriodMaxDays: query.noticePeriodMaxDays,
    includeUniqueCandidatesCount: true,
    page: 0,
    size: downloadSettings?.recordsDownloadLimit ?? 500,
    datesUnionBy: query.datesUnionBy ?? 'CREATED_OR_UPDATED_BETWEEN',
    queryType: query.queryType ?? 'none',
    columns: downloadSettings.allowedColumns,
    jobLocations: [],
    candidateLocations: [],
    currentStageCurrentStatusPairs: [],
    fieldsToDownload:
      downloadSettings.allowedColumns?.map((columnName) => columnName).join(',') ??
      'Candidate Email,Candidate Name,Candidate Phone,Client Name,Client Recruiter Name,Current Country,Current Location,Expected Salary,Job Account Manager Email,Job Account Manager Name,Job Location,Job Location Country,Job Posted Date,Job Title,Job Type,Recruiter Email,Recruiter Name,Source,Stage,Stage Date,Stage Status,Submitted Date,Team,Wisestep Job Code,Work Authorisation',
  };
};
const prefixUrl = (source) => {
  switch (source) {
    case 'Applications':
    case 'uploaded':
    case 'talentpool':
      return `candidatesearch/api/candidate/download/`;
    case 'submissions':
      return 'candidatesearch/api/submission/download/';
    default:
      return `candidatesearch/api/mapping/download/`;
  }
};

export const urlAndQueryBuilderDownloadCandidates = (
  downloadSettings: IDataDownloadSettingsDTO,
  _query: IJobCandidateInteraction,
  type: string,
  source?: string
) => {
  const payload = CandidatesDownloadPayload(_query, downloadSettings);
  const url = `${prefixUrl(source)}${type}`;
  return { payload, url };
};

export const handleCandidateDownload = async (
  type: string,
  query: IJobCandidateInteraction,
  allowedColumns?: string[],
  source?: string
) => {
  try {
    const downloadSettings: IDataDownloadSettingsDTO = await (await getDataDownloadSettings()).data;
    if (allowedColumns)
      downloadSettings.allowedColumns =
        allowedColumns && allowedColumns.length > 0
          ? allowedColumns
          : downloadSettings.allowedColumns;
    const payload = urlAndQueryBuilderDownloadCandidates(downloadSettings, query, type, source);
    const payloadForDownload = payload?.payload;
    downloadHelper(await downloadCandidatesData(payload.url, payloadForDownload));
    return 'success';
  } catch (error) {
    console.log(error);
    return 'failure';
  }
};

export const handleSubmissionCandidateDownload = async (
  type: string,
  query: NewSubmissionDownloadPayLoad
) => {
  try {
    const url = `/candidatesearch/api/candidate/submission/download/${type}`;
    downloadHelper(await downloadSubmissionCandidatesData(url, query));
    return 'success';
  } catch (error) {
    console.error('Error during candidate download:', error);
    return 'failure';
  }
};

export const handleNewSubmissionsDownload = async (
  type: string,
  query: NewSubmissionDownloadPayLoad
) => {
  try {
    downloadHelper(await downloadSubmissionsNew(type, query));
    return 'success';
  } catch (error) {
    console.log(error);
    return 'failure';
  }
};

export const bulkJobsDownloadPayload = (query: IJobSearchFilterDTO, allowedColumns: string[]) => {
  return {
    ...query,
    ...(query.postedOnJobBoardFromDate && {
      postedOnJobBoardFromDate: formattedDateISO(query.postedOnJobBoardFromDate ?? ''),
    }),
    ...(query.postedOnJobBoardToDate && {
      postedOnJobBoardToDate: formattedDateISO(query.postedOnJobBoardToDate ?? ''),
    }),
    ...(query.updatedFromDate && {
      updatedFromDate: formattedDateISO(query.updatedFromDate ?? ''),
    }),
    ...(query.updatedToDate && { updatedToDate: formattedDateISO(query.updatedToDate ?? '') }),
    postedOnJobBoardName: query.postedOnJobBoardName,
    searchAcrossTeams: query.searchAcrossTeams,
    postedOnJobBoardBy: query.postedOnJobBoardBy,
    jobSource: query.jobSource,
    tags: query.tags,
    postedByRecruiterEmails: query.postedByRecruiterEmails,
    includeUniqueCandidatesCount: true,
    page: 0,
    size: 50,
    sort: query.sort ?? ['_score,desc'],
    jobStatus: query.jobStatus,
    jobType: query.jobType,
    locations: query.locations,
    query: query.query,
    postedByAccountManagerEmails: query.postedByAccountManagerEmails ?? [],
    ...(query.postedFromDate && {
      postedFromDate: formattedDateISO(query.postedFromDate ?? ''),
    }),
    ...(query.postedToDate && {
      postedToDate: formattedDateISO(query.postedToDate ?? ''),
    }),
    submissionsCountRange: query.submissionsCountRange,

    fieldsToDownload:
      allowedColumns?.map((columnName) => columnName).join(',') ??
      ' "title,jobCode,locations,description,compensation,tags',
  };
};
export const urlAndQueryBuilderDownloadJobs = (
  allowedColumns: string[],
  query: IJobSearchFilterDTO
) => {
  const payload = bulkJobsDownloadPayload(query, allowedColumns);
  const url = `jobsearch/api/_search/jobs/advanced.xls?filter=${JSON.stringify(
    allowedColumns
  )}&jobLocationsData=${encodeURIComponent(
    JSON.stringify({})
  )}&candidateLocationsData=${encodeURIComponent(
    JSON.stringify({ candidateLocations: [] })
  )}&currentStageCurrentStatusData=${encodeURIComponent(
    JSON.stringify({})
  )}&_csrf=${getCookieByName(
    'XSRF-TOKEN'
  )}&Authorization=Bearer ${getAuthToken()}&X-Workspace-Token=${getWorkspaceToken()}`;
  return { payload, url };
};

export const bulkJobsDownloader = async (query: IJobSearchFilterDTO, allowedColumns: string[]) => {
  try {
    const downloadSettings: IDataDownloadSettingsDTO = await (await getDataDownloadSettings()).data;
    const payload = urlAndQueryBuilderDownloadJobs(
      allowedColumns ?? downloadSettings.allowedColumns,
      query
    );
    const payloadForDownload = payload?.payload;
    downloadHelper(await downloadJobsData(payload.url, formatter(payloadForDownload)));
    return 'success';
  } catch (error) {
    console.log(error);
    return 'failure';
  }
};

export const urlAndQueryBuilderDownloadWorkspaceUsers = (
  allowedColumns: string[],
  userStatusData: string[],
  requiresMFA: boolean
) => {
  const url = `/api/workspace/getuser-by-status.csv/${requiresMFA}?filter=${JSON.stringify(
    allowedColumns
  )}&userStatusData=${encodeURIComponent(
    JSON.stringify({ userStatusData })
  )}&_csrf=${getCookieByName(
    'XSRF-TOKEN'
  )}&Authorization=Bearer ${getAuthToken()}&X-Workspace-Token=${getWorkspaceToken()}`;
  return { url };
};

export const handleWorkspaceUsersDownload = async (
  userStatusData: string[],
  requiresMFA: boolean
) => {
  try {
    const downloadSettings: IDataDownloadSettingsDTO = await (await getDataDownloadSettings()).data;
    const payload = urlAndQueryBuilderDownloadWorkspaceUsers(
      downloadSettings.allowedColumns,
      userStatusData,
      requiresMFA
    );
    downloadHelper(await downloadWorkspaceUsersData(payload.url));
    return 'success';
  } catch (error) {
    console.log(error);
    return 'failure';
  }
};

export const formatter = (data: IJobSearchFilterDTO) => {
  const payload = {};
  Object.keys(data).map((key) => {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (value === 0 || value) {
        if (key === 'sort') {
          if (value)
            value.map((_i, index) => {
              const obj = value[index];
              if (typeof obj === 'string') {
                const t = `${key}[${index}]`;
                payload[t] = obj;
              }
            });
        } else if (Object.prototype.toString.call(value) === '[object Object]') {
          if (value.length)
            value.map((prop) => {
              const t = `${key} ${prop}`;
              payload[t] = value[prop];
            });
        } else if (Object.prototype.toString.call(value) === '[object Array]') {
          if (value.length)
            value.map((_key2, index) => {
              if (typeof value[index] === 'string') {
                payload[key] = value.join(',');
              } else {
                const s = value[index];
                const t = `${key}[${index}]`;
                Object.keys(s).map((key) => {
                  payload[`${t}.${key}`] = s[key];
                });
              }
            });
        } else {
          payload[key] = value;
        }
      }
    }
  });
  const searchParams = new URLSearchParams(payload);
  return searchParams;
};
